import { DateTime } from "luxon"
import { useContext, useEffect } from "react"
import { useFormikContext } from "formik"

import styles from "../../../styles/Form.module.css"
import { FormContext } from "../../../context/formContext"

export default function SessionLength({ field, index }) {
  const formik = useFormikContext()
  const form = useContext(FormContext)

  const startTime = formik.values.session_start_time
  const endTime = formik.values.session_end_time

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (startTime && endTime) {
      const end = DateTime.fromJSDate(endTime).set({ millisecond: 0, second: 0 }) || 0
      const start = DateTime.fromJSDate(startTime).set({ millisecond: 0, second: 0 }) || 0
      const diffInMinutes = end.diff(start, "minutes").toObject()

      if (diffInMinutes.minutes?.toFixed(0) !== formik.values[field.field_name]) {
        formik.setFieldValue(
          field.field_name,
          diffInMinutes.minutes?.toFixed(0)
        )
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startTime, endTime])

  return (
    <div className={styles.hidden} style={{ order: index }}>
      <input
        type="hidden"
        name={field.field_name}
        value={formik.values[field.field_name]}
      />
    </div>
  )
}
